module.exports = __webpack_public_path__ + "img/f3.9d8b823f.png";